import { useContext } from "react";

import { UserContext } from "../contexts";
import { UserContextType } from "../contexts/UserContext";

export default function useUser(): UserContextType {
  return useContext(UserContext);
}
